import { getIsStandalonePWA } from "components/PWA/helpers/getIsStandalonePWA";
import { analyticsTrackerV2 } from "contexts/ScopelyIdentityProvider/configv2";
import sequenceInstance from "contexts/SessionSequenceProvider";
import { browserName, isMobile } from "react-device-detect";
import { getPlatform } from "utils/platform";
import {
	IInvoiceReponse,
	IUserTracker,
	IWebStoreContextApi,
	IWebStoreContextApiProps
} from "../types";

interface IGetLoyaltyBuyProps extends IWebStoreContextApiProps {
	logout: () => void;
	setUserTracker: React.Dispatch<React.SetStateAction<IUserTracker | null>>;
}

const getLoyaltyBuy = ({
	axios,
	authToken,
	backendUri,
	popups,
	createHeaders,
	debug,
	setUserTracker,
	syntheticId,
	sessionId
}: IGetLoyaltyBuyProps): IWebStoreContextApi["loyaltyBuy"] => {
	const loyaltyBuy: IWebStoreContextApi["loyaltyBuy"] = async (
		offerId: string,
		dipId?: string
	) => {
		debug.log({
			iconText: "loyaltyBuy:",
			message: [`Buying loyalty offer ${offerId}`]
		});

		const queryParams: {
			offerId: string;
			dipId?: string;
		} = {
			offerId: offerId
		};

		if (dipId) {
			queryParams.dipId = dipId;
		}
		const deviceToken = analyticsTrackerV2.getDeviceToken();
		const platform = getPlatform();
		const requestConfig = {
			baseURL: backendUri,
			headers: createHeaders({
				"Content-Type": "text/plain; charset=utf-8",
				Authorization: `Bearer ${authToken?.value}`,
				"X-GSN-WEBSTORE-DEVICE-TYPE": isMobile ? "mobile" : "desktop",
				"X-GSN-WEBSTORE-BROWSER-TYPE": browserName,
				"X-GSN-WEBSTORE-SYNTHETIC-ID": syntheticId,
				"X-SCOPELY-WEBSTORE-SESSION-ID": sessionId,
				"X-SCOPELY-WEBSTORE-LAUNCH-SOURCE": getIsStandalonePWA()
					? "pwa"
					: "web",
				"X-SCOPELY-WEBSTORE-SESSION-REQUEST-SEQUENCE": sequenceInstance
					.incrementAndGetSequence()
					.toString(),
				"X-SCOPELY-WEBSTORE-PLATFORM": platform,
				"X-TITAN-DEVICE-TOKEN": deviceToken ? deviceToken : "",
				"X-TITAN-METADATA": JSON.stringify({
					app_version: process.env.REACT_APP_WEBSTORE_RELEASE_VERSION,
					environment_id: process.env.REACT_APP_SCOPELY_ANALYTICS_ENVIRONMENT_ID
				})
			}),
			params: queryParams
		};
		const uri = "/rest/store/loyalty/purchase";
		const response = await axios
			.post<IInvoiceReponse>(uri, {}, requestConfig)
			.then((response) => {
				if (!!response.data && response.data.success) {
					setUserTracker(response.data.userTracker);
					return response.data;
				} else {
					popups.handleErrorResponse({ response });
				}
			})
			.catch((err) => {
				popups.handleErrorResponse(err);
			});

		return typeof response === "number" ? response : response?.success;
	};

	return loyaltyBuy;
};

export default getLoyaltyBuy;
